export default function hexToRgb(hex: string): [number, number, number] {
  if (!hex) return [0, 0, 0];
  const parsed = hex.replace("#", "");
  const bigint = parseInt(parsed, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}
